<nz-spin nzTip='Checking...' [nzSpinning]="loading" [nzSize]="'large'">
  <form nz-form nzLayout="vertical" [formGroup]="form" (ngSubmit)="onSubmit()">

    <nz-alert *ngIf="scope === 'expired'" nzType="error"
              [nzMessage]=message style="margin-bottom: 10%">
      <ng-template #message>
        <span class="font-icon-color-exclude-group">Your password has expired, please select a new password</span>
      </ng-template>
    </nz-alert>

    <nz-form-item *ngIf="scope === 'expired'">
      <nz-form-control>
        <nz-form-label [nzRequired]="true">Old Password </nz-form-label>
        <nz-input-group [nzPrefix]="prefixLock" nzSize="large" [nzSuffix]="suffixTemplate">
          <input nz-input formControlName="oldPassword" name="old_password"
                 placeholder="Old password" [type]="oldPasswordVisible ? 'text' : 'password'" id="old-password" autocomplete="off">
        </nz-input-group>
        <ng-template #suffixTemplate>
          <em nz-icon [nzType]="oldPasswordVisible ? 'eye-invisible' : 'eye'"
              (click)="oldPasswordVisible = !oldPasswordVisible"></em>
        </ng-template>

      </nz-form-control>

      <app-password-validator [form]="this.form" [type]="'OldPassword'"></app-password-validator>

    </nz-form-item>

    <nz-form-item *ngIf="scope !== 'expired'">
      <nz-form-label [nzRequired]="true">Email Address</nz-form-label>
      <nz-form-control [nzErrorTip]="f.email.errors?.message">
        <nz-input-group [nzPrefix]="prefixUser" nzSize="large">
          <input type="text" nz-input formControlName="email" name="email" placeholder="Your email address"
                 autocomplete="off" id="email">
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzRequired]="true">New Password</nz-form-label>
      <nz-form-control [nzErrorTip]="passwordErrorTipTpl">
        <nz-input-group [nzPrefix]="prefixLock" nzSize="large" [nzSuffix]="suffixTemplate">
          <input nz-input formControlName="password" name="password" placeholder="New password"
                 [type]="passwordVisible ? 'text' : 'password'" id="password" autocomplete="off" >
        </nz-input-group>
        <ng-template #suffixTemplate>
          <em nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
              (click)="passwordVisible = !passwordVisible"></em>
        </ng-template>
      </nz-form-control>

      <ng-template #passwordErrorTipTpl>
        <app-password-validator [form]="this.form" [type]="'Password'"></app-password-validator>
      </ng-template>
    </nz-form-item>

    <nz-form-item>
      <nz-form-control>
        <nz-form-label [nzRequired]="true">New Password Confirmation</nz-form-label>
        <nz-input-group [nzPrefix]="prefixLock" nzSize="large" [nzSuffix]="suffixTemplate1">
          <input nz-input formControlName="passwordConfirmation" name="password_confirmation"
                 placeholder="Confirm new password" [type]="passwordConfirmationVisible ? 'text' : 'password'" id="password-confirmation" autocomplete="off">
        </nz-input-group>

        <ng-template #suffixTemplate1>
          <em nz-icon [nzType]="passwordConfirmationVisible ? 'eye-invisible' : 'eye'"
              (click)="passwordConfirmationVisible = !passwordConfirmationVisible"></em>
        </ng-template>
      </nz-form-control>
      <app-password-validator [form]="this.form" [type]="'PasswordConfirmation'"></app-password-validator>
    </nz-form-item>

    <app-captcha [form]="form"
                 (resolved)="captchaResolved($event)">
    </app-captcha>

    <nz-form-item class="margin-bottom-regular">
      <nz-form-control>
        <button [nzLoading]="loading"
                class="primary-button"
                [disabled]="!form.valid"
                nz-button nzSize="large" nzType="primary" nzBlock id="submit">Change password
        </button>
      </nz-form-control>
    </nz-form-item>

    <div class= "semibold-font font-size-large-title font-icon-color-primary-black margin-bottom-small">Password Guidelines:</div>
    <ul>
      <li>Password length should be at least 8 characters.</li>
      <li>Password should contain at least 3 of the 4 variations of lowercase, uppercase, number, symbol.</li>
      <li>Password cannot contain references to the user's first name,last name or company name.</li>
    </ul>

  </form>

  <ng-template #prefixUser><em nz-icon nzType="user"></em></ng-template>
  <ng-template #prefixLock><em nz-icon nzType="lock"></em></ng-template>
</nz-spin>
